import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { useEffect } from 'react';
import { PurchaseMotionCTA } from 'purchase-motions-components/components/PurchaseMotionCTA/PurchaseMotionCTA';
import Products from 'merchandise-lib/constants/Product';
import { track } from '../../_core/common/eventTracking/tracker';
import { getProductNameTextFromApiName } from '../../_core/common/adapters/getProductNameText';
import getUpgradeBannerTranslations from '../../_core/utils/getUpgradeBannerTranslations';
import { writeUpgradeConfigToLocalStorage } from '../../_core/utils/upgradeConfigCache';
import { getUpgradeConfigTrackingProperties, updateViewedUpgradePointsCache } from '../utils';
import BuiltOnHubSpotBadge from './BuiltOnHubSpotBadge';
import DefaultBanner from './DefaultBanner';
import { getTrackingDataFromUpgradeConfig } from '../../_core/utils/getTrackingDataFromUpgradeConfig';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const HSOC_PRODUCTS = new Set([Products.CORE_SEATS_STARTER_HSOC, Products.CORE_SEATS_PROFESSIONAL_HSOC, Products.CORE_SEATS_ENTERPRISE_HSOC, Products.FRONT_OFFICE_SEATS_PROFESSIONAL, Products.FRONT_OFFICE_SEATS_ENTERPRISE, Products.GTM_SEATS_STARTER, Products.GTM_SEATS_PROFESSIONAL, Products.GTM_SEATS_ENTERPRISE, Products.OPS_SEATS_PROFESSIONAL, Products.OPS_SEATS_ENTERPRISE]);
const RemoveBrandingBanner = ({
  upgradePoint,
  'data-test-id': dataTestId = 'remove-branding-banner'
}) => {
  useEffect(() => {
    updateViewedUpgradePointsCache(upgradePoint.upgradeKey, () => {
      track('interaction', Object.assign({
        action: 'viewed upgrade point'
      }, getUpgradeConfigTrackingProperties(upgradePoint)));
    });
  }, [upgradePoint]);
  const {
    bannerTitle,
    bannerSubtitle
  } = getUpgradeBannerTranslations(upgradePoint.content);
  const bestFitApiName = upgradePoint.bestFitApiNameForPurchase;
  const isHsoc = HSOC_PRODUCTS.has(bestFitApiName);
  const subtitleText = isHsoc ? I18n.text('upgrades.removeBrandingBanner.hsocSubtitle', {
    productName: getProductNameTextFromApiName(bestFitApiName)
  }) : bannerSubtitle;
  return /*#__PURE__*/_jsx(DefaultBanner, {
    dataTestId: dataTestId,
    icon: /*#__PURE__*/_jsx(BuiltOnHubSpotBadge, {}),
    titleText: /*#__PURE__*/_jsx(_Fragment, {
      children: bannerTitle
    }),
    subtext: /*#__PURE__*/_jsx(_Fragment, {
      children: subtitleText
    }),
    button: /*#__PURE__*/_jsx(PurchaseMotionCTA, {
      "data-test-id": "remove-branding-pricing-page-redirect-button",
      purchaseMotion: "PRICING_PAGE_REDIRECT",
      apiName: upgradePoint.bestFitApiNameForPurchase,
      trackingData: getTrackingDataFromUpgradeConfig(upgradePoint),
      uiButtonProps: {
        use: 'secondary',
        size: 'extra-small',
        truncate: false
      },
      ctaProps: {
        redirectDestination: 'upgradePage'
      },
      isUpgradePoint: true,
      upgradeConfig: upgradePoint,
      onClick: () => writeUpgradeConfigToLocalStorage(upgradePoint),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.upgradeButton.default"
      })
    })
  });
};
export default RemoveBrandingBanner;